:host {
  @include font(bold);

  align-items: center;
  color: $color-gray-text;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: $size-text-smaller;
  height: 16px;
  justify-content: center;
  line-height: 1;
  position: relative;
  width: 24px;

  > img {
    border: 0 none;
    box-shadow: 0 0 2px rgb(0 0 0 / 20%);
    height: 100%;
    left: 0;
    object-fit: contain;
    position: absolute;
    top: 0;
    width: 100%;
  }
}

:host([size="s"]) {
  height: 16px;
  width: 24px;
}

:host([size="m"]) {
  height: 20px;
  width: 30px;
}

:host([size="l"]) {
  height: 24px;
  width: 36px;
}
